import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderDetailPage from './pages/OrderDetailPage';
import AdminDashboard from './pages/AdminDashboard';
import WhatsAppButton from './components/WhatsAppButton';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Redirect legacy /solutions to /pricing (All Services) */}
            <Route path="/solutions" element={<Navigate to="/pricing" replace />} />
            <Route path="/pricing" element={<PricingPage />} />
            {/* Redirect legacy routes to homepage */}
            <Route path="/how-it-works" element={<Navigate to="/" replace />} />
            <Route path="/resources" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            {/* Redirect legacy /services to /pricing */}
            <Route path="/services" element={<Navigate to="/pricing" replace />} />
            {/* Individual service detail pages */}
            <Route path="/service/:id" element={<ServiceDetailPage />} />
            {/* Hidden admin login - non-obvious URL */}
            <Route path="/internal-access-portal" element={<LoginPage />} />
            {/* Redirect legacy auth routes to homepage */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/register" element={<Navigate to="/" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/checkout/:orderId" element={<CheckoutPage />} />
            <Route path="/orders/:orderId" element={<OrderDetailPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <WhatsAppButton />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;